import React from 'react';
import PropTypes from 'prop-types';
import { FormText } from '~/components/FormControl';
import { Row, Col } from 'react-bootstrap';
import ExtraGranted from '../Econ/ExtraGranted';
import FreeGranted from '../Econ/FreeGranted';
import Others from '../Econ/Others';
import PercentageChange from '../Econ/PercentageChange';
import RankCheck from '../Econ/RankCheck';

function Econ({ asyncApiCall }) {
    return (
        <>
            <Row className={'justify-content-center'}>
                <FormText
                    name="name"
                    asyncApiCall={asyncApiCall}
                    sm={2}
                />
            </Row>

            <Row className={'justify-content-around'}>
                <Col>
                    <ExtraGranted />
                </Col>

                <Col>
                    <FreeGranted />
                </Col>

                <Col>
                    <PercentageChange />
                </Col>

                <Col className="d-flex flex-column">
                    <Others />
                </Col>
            </Row>

            <h2 className="text-center">
                <u>Condition Check</u>
            </h2>
            <Row>
                <Col sm={3}>
                    <RankCheck />
                </Col>
            </Row>
        </>
    );
}

Econ.propTypes = {
    asyncApiCall: PropTypes.func.isRequired,
};

export default Econ;
